import { render } from "./zscqxq.vue?vue&type=template&id=b2d1e8c2&scoped=true"
import script from "./zscqxq.vue?vue&type=script&lang=js"
export * from "./zscqxq.vue?vue&type=script&lang=js"

import "./zscqxq.vue?vue&type=style&index=0&id=b2d1e8c2&scoped=true&lang=scss"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2d1e8c2"]])

export default __exports__